module.exports = __webpack_public_path__ + "img/hr-branch-particle-shadow-07.9085d77b.png";